import React from 'react'
import {
    Box,
    Button,
    Grid,
} from '@material-ui/core'
import { useAppDispatch } from '../../../../store'
import { ROUTES } from '../../../../constants'
import { useHistory } from 'react-router-dom'
import { unwrapResult } from '@reduxjs/toolkit'
import { SideBar } from '../../../../components/side-bar'
import { Content } from '../../../../components/content'
import { navLinksOrganization, validation } from '../../../../services'
import { Field, Form, Formik } from 'formik'
import { ProviderProps } from '../../../../store/types'
import { TextField } from 'formik-material-ui'
import { providers } from '../../../../store/slices/provider'

export function ProviderCreatePage(): JSX.Element {
    const dispatch = useAppDispatch()
    const history = useHistory()

    const initialValues: ProviderProps = {
        name: '',
    }

    return (
        <Formik
            initialValues={initialValues}
            enableReinitialize
            onSubmit={(values, { setSubmitting }) => {
                dispatch(providers.actions.create(values))
                    .then(unwrapResult)
                    .then(() => {
                        history.push(ROUTES.ORGANIZATION_PROVIDERS)
                    })
                setSubmitting(false)
            }}
        >
            {({ submitForm }) => (
                <Form>
                    <Box display="flex">
                        <SideBar navLinks={navLinksOrganization}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={submitForm}
                            >
                                Сохранить
                            </Button>
                        </SideBar>
                        <Content loading={false} notFoundContent={false} title={'Создание поставщика'}>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Field
                                        component={TextField}
                                        label="Название"
                                        name="name"
                                        fullWidth
                                        validate={validation.required}
                                    />
                                </Grid>
                            </Grid>
                        </Content>
                    </Box>
                </Form>
            )}
        </Formik>

    )
}